import React from 'react';
import { Svg, Path } from '@react-pdf/renderer';

const PdfInfoIcon = () => {
	return (
		<Svg width="13" height="13" viewBox="0 0 12 13" fill="none">
			<Path
				d="M6 1.5C3.24 1.5 1 3.74 1 6.5C1 9.26 3.24 11.5 6 11.5C8.76 11.5 11 9.26 11 6.5C11 3.74 8.76 1.5 6 1.5ZM6 9C5.725 9 5.5 8.775 5.5 8.5V6.5C5.5 6.225 5.725 6 6 6C6.275 6 6.5 6.225 6.5 6.5V8.5C6.5 8.775 6.275 9 6 9ZM6.5 5H5.5V4H6.5V5Z"
				fill="#720017"
			/>
		</Svg>
	);
};

export default PdfInfoIcon;
